import {createAnatomy} from '@zag-js/anatomy';

export const widgetAnatomy = createAnatomy(`widget`).parts(
  `container`,
  `footer`,
  `body`,
  `header`,
  `list`,
  `title`,
  `icon`,
  `empty`,
  `error`,
  `skeleton`,
);

export const parts = widgetAnatomy.build();

export type Part = keyof typeof parts;
